import apiClient from "./api";

async function getHotel(hotelId) {
    try {
      const response = await apiClient.get('/get-hotel/' + hotelId);
      return response;
    } catch (error) {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        return { success: false, message: "No response received", details: error.request };
      } else {
        return { success: false, message: "Request setup error", details: error.message };
      }
    }
  }

  async function createHotel(data) {
    try {
      console.log(data)
      const response = await apiClient.post('/create-hotel', data);
      return response;
    } catch (error) {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        return { success: false, message: "No response received", details: error.request };
      } else {
        return { success: false, message: "Request setup error", details: error.message };
      }
    }
  }
  
  async function getAllHotels() {
    try {
      const response = await apiClient.get('/all-hotels/');
      return response;
    } catch (error) {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        return { success: false, message: "No response received", details: error.request };
      } else {
        return { success: false, message: "Request setup error", details: error.message };
      }
    }
  }

  
async function updateHotel(hotelId, data) {
  try {
    const response = await apiClient.post('/update-hotel/' + hotelId, data);
    return response;
  } catch (error) {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      return { success: false, message: "No response received", details: error.request };
    } else {
      return { success: false, message: "Request setup error", details: error.message };
    }
  }
}

async function deleteHotel(hotelId) {
  try {
    const response = await apiClient.post('/delete-hotel/' + hotelId);
    return response;
  } catch (error) {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      return { success: false, message: "No response received", details: error.request };
    } else {
      return { success: false, message: "Request setup error", details: error.message };
    }
  }
}


  export { getHotel, createHotel, getAllHotels, updateHotel, deleteHotel }